// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BOsTa","top":"styles_top__2_Jgi"};